// src/calendar/calendarUtils.js
export const startOfDay = (d) => {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};
export const isSameDay = (a, b) => {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
};
export const addDays = (d, days) => {
  const x = new Date(d);
  x.setDate(x.getDate() + days);
  return x;
};
// Week starts Sunday (0)
export const startOfWeekSunday = (d) => {
  const x = startOfDay(d);
  const day = x.getDay(); // 0 = Sunday
  x.setDate(x.getDate() - day);
  return x;
};
export const fmtYMD = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
};
export const fmtFriendly = (d) => {
  return d.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
export const getRange = (baseDate, mode, VIEW) => {
  if (mode === VIEW.DAY) {
    const s = fmtYMD(baseDate);
    return { start: s, end: s };
  }
  if (mode === VIEW.WEEK) {
    const sDate = startOfWeekSunday(baseDate);
    const eDate = addDays(sDate, 6);
    return { start: fmtYMD(sDate), end: fmtYMD(eDate) };
  }
  // MONTH — use full 42-day grid boundaries so weeks bleeding into adjacent months are included
  const first = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
  const gridStart = startOfWeekSunday(first);
  const gridEnd = addDays(gridStart, 41);
  return {
    start: fmtYMD(gridStart),
    end: fmtYMD(gridEnd),
  };
};